import * as yup from 'yup';

export const login = yup.object().shape({
  email: yup.string().email().required(),
});

export const email = yup.object().shape({
  email: yup.string().email().required(),
});
